import { Logger } from "./logger";

declare var CookieScript: any;

export class CookieHelper {

    private cookieInstance: any;
    private init: boolean = false;

    constructor(private $log: Logger) {
        window.addEventListener('CookieScriptLoaded', () => {
            this.initCookieHelper();
            this.init = true;
        });
    }

    /**
     * Inits the cooke Instance
     */
    public initCookieHelper(): void {
        this.cookieInstance = CookieScript?.instance?.currentState();
        this.$log.debug(this.cookieInstance);
    }

    /**
     * Checks if a cookie category is accepted
     * @param testFor the string of the cookiecategory which you wanna test for.
     * @returns true if category is accepted and false if not or if nothing is accepted
     */
    public testValidity(testFor: "performance" | "targeting" | "functionality" | "strict"): boolean {
        if (!this.init) {
            return false;
        }
        this.cookieInstance = CookieScript?.instance?.currentState();
        if (this.cookieInstance?.action == 'accept') {
            if (this.cookieInstance.categories.includes(testFor)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}
